export default __webpack_public_path__ + "static/pw-8b31b83d12b013f1144d11cf7aa61d00.svg";